import parse from 'html-react-parser'
import { type ReactElement } from 'react'
import BookFootnotes, { type BookFootnotesProps } from '#app/components/common/book-footnotes.tsx'
import {
  encodedApostrophe,
  encodedAmpersand,
  encodedFwdSlash,
  encodedHyphen,
  encodedMDash,
  encodedQuote,
  encodedVertLine,
  encodedHashmark,
} from '#app/components/ui/constants.js'

const FootnotesBeingAVampireRoute = () => {

  const v1C1Element: ReactElement =
    <div className='container'>
      <div aria-label='Volume 1 Chapter 1' className='section justify-start'>
        <div aria-label='Volume 1 Chapter 1 Scene 1'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.1.1 ${encodedHyphen} November 3, 2019; POV: Rix; CW: vampire violence, non${encodedHyphen}graphic sexual content.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://www.lostlakecafe.com/'
              aria-label='link to Lost Lake Cafe'
              className='link'
            >
              Lost Lake Cafe</a>, 1505 10th Ave, Seattle, WA 98122, <a
                href='https://trip101.com/article/24-hour-restaurants-in-seattle'
                aria-label='link to 24-hour restaurants in Seattle in 2019'
                className='link'
              >
              {parse(`2020 ${encodedHyphen} 2021 only until midnight; 2022: Thu${encodedHyphen}Sat 7am ${encodedHyphen} 2am ${encodedVertLine} Sun${encodedHyphen}Wed 7am ${encodedHyphen} 12am).`)}
            </a> <a
              href='https://www.spl.org/hours-and-locations/capitol-hill-branch'
              aria-label='link to Seattle Public Libraries Capitol Hill Branch hours'
              className='link'
            >
              Capitol Hill Branch of the Seattle Public Libraries
            </a>, 425 Harvard Ave E, Seattle, WA 98102. <a
              href='https://www.maserati.com/us/en'
              aria-label='link to Maserati Luxury Cars'
              className='link'
            >
              Maserati Luxury Cars
            </a>.
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: Rix ${encodedHyphen} main character; male vampire in Seattle on the eve of COVID${encodedHyphen}19. Robert ${encodedHyphen} secondary character; male vampire; leader of a group of vampires on Capitol Hill. Nalini ${encodedHyphen} tertiary character; female human; Rix${encodedApostrophe}s manager at an Indian tech company that he contracts for. Lauren ${encodedHyphen} quaternary character; male human; a waitperson at Lost Lake Cafe who becomes Rix${encodedApostrophe}s victim. Arnoldo ${encodedHyphen} quaternary character; male vampire, now deceased; former leader of the Capitol Hill group of vampires.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 1 Scene 2'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.1.2 ${encodedHyphen} November 10, 2019; POV: Rix; CW: police abduction, loss of housing.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://en.wikipedia.org/wiki/First_impeachment_of_Donald_Trump'
              aria-label='link to First Trump Impeachment'
              className='link'
            >
              First Trump impeachment.</a> <a
                href='https://www.drought.gov/states/washington'
                aria-label='link to Ongoing Drought in Washington State'
                className='link'
              >
              Ongoing drought in Washington State.
            </a> {parse(`Pepe${encodedApostrophe}s Garden, about 411 13th Ave E, on Capitol Hill.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: DB ${encodedHyphen} quaternary character; male vampire.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 1 Scene 3'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.1.3 ${encodedHyphen} November 10, 2019; POV: Rix.`)}
          </div>
          <div className='content-page-content-no-spread'>
            Starbucks; 1410 E John St, Seattle, WA 98112. Lost Lake Cafe (see 1.1.1); Amazon headquarters, 440 Terry Ave N, Seattle, WA 98109.
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: James ${encodedHyphen} secondary character; male vampire; member of Robert${encodedApostrophe}s group of vampires (see 1.1.1); in a relationship with Darah. Darah ${encodedHyphen} tertiary character; female human; in a relationship with James.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 1 Scene 4'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.1.4 ${encodedHyphen} November 11, 2019; POV: Rix; CW: unwanted sexual advances.`)}
          </div>
          <div className='content-page-content-no-spread'>
            Amazon (see 1.1.3).
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 1 Scene 5'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.1.5 ${encodedHyphen} November 14 to 15, 2019; POV: Rix; CW: references to sexual behaviors.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://www.spl.org/hours-and-locations/central-library'
              aria-label='link to Seattle Public Libraries Central Branch'
              className='link'
            >Central Branch of the Seattle Public Libraries</a>, 1000 Fourth Ave., Seattle, WA 98104.
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 1 Scene 6'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.1.6 ${encodedHyphen} November 14, 2019; POV: Rix; CW: loss of housing, swearing.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Rock Box, 1603 Nagle Pl, Seattle, WA 98122. Cal Anderson Park, Nagle Pl ${encodedAmpersand} E Pine St (courtyard), on Capitol Hill. Peace for the Streets by Kids from the Streets (PSKS) Youth Shelter (2022; Plymouth Housing), 1602 18th Ave, Seattle, WA 98122, PSKS did, indeed, `)}
            <a
              href='https://www.seattletimes.com/seattle-news/homeless/a-seattle-youth-homeless-shelter-faces-its-final-days-and-its-young-residents-confront-an-uncertain-future/'
              aria-label='link to Seattle Times article documenting PSKS shutdown'
              className='link'
            >
              shut down at the end of 2019
            </a>, {parse(`after I wrote this original story. Most unfortunate timing for the youths who depended on it${encodedMDash}not only because it was the dead of winter, but COVID${encodedHyphen}19 was already circulating. The house with the perpetually blue${encodedHyphen}tarped roof is right across from Plymouth Housing. This house was still standing in June 2022, but there have been at least two attic fires (or more?) that I${encodedApostrophe}ve documented using Google Street View.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: Jewel ${encodedHyphen} tertiary character; trans${encodedHyphen}female vampire; member of Robert${encodedApostrophe}s group of vampires. Dan ${encodedHyphen} tertiary character; Deaf male vampire; member of Robert${encodedApostrophe}s group of vampires; partnered with Jewel.`)}
          </div>
        </div>
      </div>
    </div>
  const v1C2Element: ReactElement =
    <div className='container'>
      <div aria-label='Volume 1 Chapter 2' className='section justify-start'>
        <div aria-label='Volume 1 Chapter 2 Scene 1'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.2.1 ${encodedHyphen} November 15 to 17, 2019; POV: Rix.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://en.wikipedia.org/wiki/Lake_Washington_Ship_Canal'
              aria-label='link to Lake Washington Ship Canal'
              className='link'
            >
              Lake Washington Ship Canal
            </a>
            {parse(`. `)}
            <a
                href='https://en.wikipedia.org/wiki/Woodland_Park_(Seattle)'
                aria-label='link to Woodland Park'
                className='link'
              >
                Woodland Park/Green Lake
              </a>
              {parse(`, entrance at N 50th St ${encodedAmpersand} Woodland Park Ave N, in the Green Lake neighborhood of North Seattle.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 2 Scene 2'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.2.2 ${encodedHyphen} November 17, 2019; POV: Rix.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://www.youtube.com/watch?v=fNFzfwLM72c'
              aria-label='link to Staying Alive by The Bee Gees'
              className='link'
            >
            {parse(`${encodedQuote}Staying Alive${encodedQuote}`)}
            </a>
            {parse(` by The Bee Gees, probably the best known CPR song, used because it${encodedApostrophe}s rhythm is appropriate for the beats per minute for CPR. In Maggie${encodedApostrophe}s neighborhood, `)}
            <a
              href='http://www.seattle.gov/documents/Departments/Fire/About/2019_Annual_Report_FINAL_Web.pdf'
              aria-label='link to Seattle Fire Station 9'
              className='link'
            >
              Seattle Fire Station 9
            </a>
            {parse(`, 3829 Linden Ave N, Seattle, WA 98103, would be the first responders. It generally takes about two to three minutes for them to arrive (I live in this neighborhood, so have direct experience), but their page lists a goal of four minutes for EMT with basic life support (CPR/defibrillator), and eight minutes for advanced support (paramedic). In speaking with a Lieutenant at Fire Station 9, I was able to validate the accuracy of my depiction of this scene${encodedMDash}if the four closest local stations (9, 21, 17 and 18, in that order) are already assisting others, the several minutes wait can go upwards of nine or ten minutes to call in a unit from North Green Lake (16). The Seattle Fire Department has excellent response times and a complex automated system for tracking the locations of the aid units (trucks, aid cars, medics) and backfilling with units from south of the Ship Canal if an area is impacted by a large event involving several of the fire stations, e.g., a large fire, like when the `)}
            <a
              href='https://www.seattletimes.com/seattle-news/seven-gables-theatre-in-u-district-in-flames/'
              aria-label='link to Seven Gables Theatre burned down'
              className='link'
            >
              Seven Gables Theatre burned down
            </a>
            {parse(` on Christmas Eve 2020. `)}
            <a
              href='https://www.uwpmt.org/public/history-medic-one'
              aria-label='link to Medic One'
              className='link'
            >
              MedicOne
            </a> 
            {parse(`was developed in Seattle in the late ${encodedApostrophe}60s and began servicing the city on March 7, 1970. `)}
            <a
              href='https://www.kensmarkets.com/'
              aria-label='link to Marketime Foods'
              className='link'
            >
              Marketime Foods
            </a>
            {parse(`; 4416 Fremont Ave N, Seattle, WA 98103. `)}
            <a
              href='https://www.lighthouseroasters.com/'
              aria-label='link to Lighthouse Roasters'
              className='link'
            >
              Lighthouse Roasters
            </a>
            ; 400 N 43rd St, Seattle, WA 98103.
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: Maggie ${encodedHyphen} primary character; female human; Nurse Practitioner who also works shifts in the ER at `)}
            <a
              href='https://www.uwmedicine.org/locations/harborview-medical-center'
              aria-label='link to Harborview Medical Center'
              className='link'
            >
              Harborview Medical Center
            </a>
            {parse(` in Seattle.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 2 Scene 3'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.2.3 ${encodedHyphen} November 18, 2019; POV: Rix.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Lighthouse Roasters (see 1.2.2). `)}
            <a
              href='https://www.washingtonpost.com/weather/2019/11/13/cold-snap-historic-proportions-hits-east-coast-over-records-fall/'
              aria-label='link to Record cold in the East'
              className='link'
            >
              Record cold in the East
            </a>
            {parse(`. ${encodedQuote}Staying Alive${encodedQuote} by The Bee Gees (see 1.2.2). `)}
            <a
              href='https://www.youtube.com/watch?v=-tJYN-eG1zk'
              aria-label='link to We Will Rock You by Queen'
              className='link'
            >
            {parse(`${encodedQuote}We Will Rock You${encodedQuote}`)}
            </a>
            {parse(` by Queen. `)}
            <a
              href='https://www.youtube.com/watch?v=jubOWUlkxuk'
              aria-label='link to Maggie May by Rod Stewart'
              className='link'
            >
            {parse(`${encodedQuote}Maggie May${encodedQuote}`)}
            </a>
            by Rod Stewart.
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 2 Scene 4'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.2.4 ${encodedHyphen} November 18 to 19, 2019; POV: Rix; CW: swearing.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`The house with the perpetually blue-tarped roof (see 1.1.6). `)}
            <a
              href='https://www.washingtonpost.com/weather/2019/11/13/cold-snap-historic-proportions-hits-east-coast-over-records-fall/'
              aria-label='link to Comparisons between the rise of fascism in the Thirties to current events'
              className='link'
            >
              Comparisons between the rise of fascism in the Thirties to current events
            </a>
            {parse(`, written August 12, 2017.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 2 Scene 5'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.2.5 ${encodedHyphen} November 20, 2019; POV: Maggie.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Harborview Medical Center Emergency Room (see 1.2.2).`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: Rama ${encodedHyphen} secondary character; male human; ER Nurse who works in the ER at Harborview Medical Center in Seattle; works for Althea. Althea ${encodedHyphen} tertiary character; female human; ER Head Nurse who works in the ER at Harborview Medical Center in Seattle; manages Rama and Maggie.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 2 Scene 6'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.2.6 ${encodedHyphen} November 20, 2019; POV: Rix.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Woodland Park/Green Lake (see 1.2.1).`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: Bryer ${encodedHyphen} secondary character; female vampire; leader of Woodland Park group of vampires; partnered with Cleve. Cleve ${encodedHyphen} secondary character; male vampire; second in command of Woodland Park group of vampires; partnered with Bryer.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 2 Scene 7'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.2.7 ${encodedHyphen} November 21 to 22, 2019; POV: Rix; CW: lack of housing.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://www.apodment.com/'
              aria-label='link to aPodment'
              className='link'
            >
              aPodment
            </a>
            {parse(`. University District Goodwill; 4552 University Way NE, Seattle, WA 98105. `)}
            <a
              href='https://kingcounty.gov/depts/transportation/metro.aspx'
              aria-label='link to King County Metro'
              className='link'
            >
              King County Metro
            </a>
            {parse(`. First Trump impeachment (see 1.1.2). The house with the perpetually blue-tarped roof (see 1.1.6).`)}
          </div>
        </div>
      </div>
    </div>
  const v1C3Element: ReactElement =
    <div className='container'>
      <div aria-label='Volume 1 Chapter 3' className='section justify-start'>
        <div aria-label='Volume 1 Chapter 3 Scene 1'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.3.1 ${encodedHyphen} November 22, 2019; POV: Rix; CW: lack of housing; sexual content; swearing.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 3 Scene 2'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.3.2 ${encodedHyphen} November 22, 2019; POV: Rix; CW: references to vampire violence against unhoused teens.`)}
          </div>
          <div className='content-page-content-no-spread'>
            Fred Meyer (Ballard), 915 NW 45th St, Seattle, WA 98107.
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: Silvan ${encodedHyphen} quaternary character; female human; owner of house where Rix and James rent a room.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 3 Scene 3'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.3.3 ${encodedHyphen} November 26, 2019; POV: Rix; CW: references to cancer treatment/loss.`)}
          </div>
          <div className='content-page-content-no-spread'>
            Lighthouse Roasters (see 1.2.2).
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 3 Scene 4'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.3.4 ${encodedHyphen} December 16, 2019; POV: Rix.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`${encodedQuote}`)}
            <a
              href='https://www.youtube.com/watch?v=uykTzLHktNI/'
              aria-label='link to Waltz Dream by The Waltz Orchestra'
              className='link'
            >
              Waltz Dream
            </a>
            {parse(`${encodedQuote} by The Waltz Orchestra. ${encodedQuote}`)}
            <a
              href='https://www.penguinrandomhouse.com/books/537515/born-a-crime-by-trevor-noah/'
              aria-label='link to Born a Crime by Trevor Noah'
              className='link'
            >
              Born a Crime
            </a>
            {parse(`${encodedQuote}. Lighthouse Roasters (see 1.2.2). ${encodedQuote}`)}
            <a
              href='https://www.youtube.com/watch?v=mWRsgZuwf_8'
              aria-label='link to Demons by Imagine Dragons'
              className='link'
            >
              Demons
            </a>
            {parse(`${encodedQuote}. `)}
            <a
              href='https://www.thestranger.com/slog/2018/11/20/35871541/long-live-the-green-lake-aqua-theater'
              aria-label='link to Green Lake Aqua Theater'
              className='link'
            >
              Green Lake Aqua Theater
            </a>
            {parse(` (in Woodland Park/Green Lake see 1.2.1).`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 3 Scene 5'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.3.5 ${encodedHyphen} December 21, 2019; POV: Rix.`)}
          </div>
          <div className='content-page-content-no-spread'>
            REI, 222 Yale Ave N, Seattle, WA 98109. Green Lake (see 1.2.1). Green Lake Aqua Theater (see 1.3.4).
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 3 Scene 6'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.3.6 ${encodedHyphen} December 24, 2019; POV: Maggie.`)}
          </div>
          <div className='content-page-content-no-spread'>
            Harborview Medical Center Emergency Room (see 1.2.5).
          </div>
        </div>
      </div>
    </div>
  const v1C4Element: ReactElement =
    <div className='container'>
      <div aria-label='Volume 1 Chapter 4' className='section justify-start'>
        <div aria-label='Volume 1 Chapter 4 Scene 1'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.4.1 ${encodedHyphen} December 27, 2019; POV: James; CW: violence, rape, assault, swearing.`)}
          </div>
          <div className='content-page-content-no-spread'>
            If you chose to skip reading this scene, here’s a short recap: Robert drags James from his job cleaning the restaurant, proceeds to beat and rape him, then sends him to Rix to extort money from him. I tried to keep the worst part short, but wanted to show how very brutal Robert can be, as well as explaining why James kowtows to him.
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://www.rainn.org/resources'
              aria-label='link to the National Sexual Assault Hotline'
              className='link'
            >
              RAINN
            </a>
            {parse(` is the National Sexual Assault Hotline: Confidential 24${encodedFwdSlash}7 Support.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: Fernando ${encodedHyphen} quaternary character; male human; runs restaurant where James works.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 4 Scene 2'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.4.2 ${encodedHyphen} December 27 to 28, 2019; POV: Rix; CW: swearing.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 4 Scene 3'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.4.3 ${encodedHyphen} December 28, 2019; POV: Rix; CW: vampire violence.`)}
          </div>
          <div className='content-page-content-no-spread'>
            Ongoing drought in Washington State (see 1.1.2); Woodland Park (see 1.2.1).
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 4 Scene 4'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.4.4 ${encodedHyphen} January 8, 2020; POV: Rix.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`${encodedQuote}`)}
            <a
              href='https://www.oceanvuong.com/'
              aria-label="link to On Earth We're Briefly Gorgeous by Ocean Vuong"
              className='link'
            >
              {parse(`On Earth We${encodedApostrophe}re Briefly Gorgeous`)}
            </a>
            {parse(`${encodedQuote} by Ocean Vuong.`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 4 Scene 5'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.4.5 ${encodedHyphen} January 8, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Lighthouse Roasters (see 1.2.2). `)}
            <a
              href='https://www.devex.com/news/covid-19-in-2020-a-timeline-of-the-coronavirus-outbreak-99634'
              aria-label='link to 2020 timeline of the Corona Virus Outbreak'
              className='link'
            >
              First reference to the new coronavirus
            </a>
            {parse(` with an unknown etiology that will be identified as COVID${encodedHyphen}19. High winds canceled `)}
            <a
              href='https://www.seattletimes.com/seattle-news/2020-arrives-in-seattle-with-a-space-needle-laser-show-as-fireworks-are-delayed-at-least-awhile/'
              aria-label='link to Seattle Times report on high winds cancelling 2020 New Years Eve'
              className='link'
            >
              {parse(`2020 New Year${encodedApostrophe}s Eve fireworks`)}
            </a>
            {parse(`. Gas Works Park; 2101 N Northlake Way, Seattle, WA 98103. Harborview Medical Center Emergency Room (see 1.2.5). The M${encodedApostrophe}s (`)}
            <a
              href='https://www.mlb.com/mariners'
              aria-label='link to the Seattle Mariners Baseball Team'
              className='link'
            >
              Seattle Mariners
            </a>
            {parse(`).`)}
          </div>
        </div>
        <div aria-label='Volume 1 Chapter 4 Scene 6'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`1.4.6 ${encodedHyphen} January 9 to 10, 2020; POV: Rix; CW: Loss of employment.`)}
          </div>
        </div>
      </div>
      <div aria-label='Volume 1 Chapter 4 Scene 7'
        className='section footnote-section'
      >
        <div className='content-page-content-no-spread'>
          {parse(`1.4.7 ${encodedHyphen} January 12, 2020; POV: Rix.`)}
        </div>
        <div className='content-page-content-no-spread'>
          {parse(`Character introductions: Matt ${encodedHyphen} tertiary character; male vampire; member of Bryer${encodedApostrophe}s pack of vampires; partnered with David. David ${encodedHyphen} tertiary character; male vampire; member of Bryer${encodedApostrophe}s pack of vampires; partnered with Matt.`)}
        </div>
      </div>
      <div aria-label='Volume 1 Chapter 4 Scene 8'
        className='section footnote-section'
      >
        <div className='content-page-content-no-spread'>
          {parse(`1.4.8 ${encodedHyphen} January 15, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19.`)}
        </div>
        <div className='content-page-content-no-spread'>
          {parse(`China shares genetic sequence of new coronavirus, WHO reported first case of COVID-19 outside China (see 1.4.5). “Born a Crime” by Trevor Noah (see 1.3.4). “On Earth We're Briefly Gorgeous” by Ocean Vuong (see 1.4.4). `)}
          <a
            href='https://littlefreelibrary.org/'
            aria-label='link to Little Free Library'
            className='link'
          >
            Little Free Library
          </a>
          {parse(`.`)}
        </div>
      </div>
      <div aria-label='Volume 1 Chapter 4 Scene 9'
        className='section footnote-section'
      >
        <div className='content-page-content-no-spread'>
          {parse(`1.4.9 ${encodedHyphen} January 18, 2020; POV: Rix.`)}
        </div>
        <div className='content-page-content-no-spread'>
          <a
            href='https://www.apple.com/'
            aria-label='link to Apple products'
            className='link'
          >
            Apple products
          </a>
          {parse(`.`)}
        </div>
      </div>
    </div>
  const v2C1Element: ReactElement =
    <div className='container'>
      <div aria-label='Volume 2 Chapter 1' className='section justify-start'>
        <div aria-label='Volume 2 Chapter 1 Scene 1'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.1.1 ${encodedHyphen} January 20, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Amtrak at King Street Station, 303 S Jackson St, Seattle, WA 98104. `)}
            <a
              href='https://www.lighthouseroasters.com/'
              aria-label='link to Lighthouse Roasters'
              className='link'
            >
              Lighthouse Roasters
            </a>
            {parse(`, 400 N 43rd St, Seattle, WA 98103. `)}
            <a
              href='https://www.devex.com/news/covid-19-in-2020-a-timeline-of-the-coronavirus-outbreak-99634'
              aria-label='link to an early World Health Organinzation report on new coronavirus'
              className='link'
            >
              The WHO produced a report
            </a>
            {parse(` on new pneumonia virus in China, China considers a lockdown in Wuhan.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: Rix ${encodedHyphen} main character; male vampire in Seattle on the eve of COVID${encodedHyphen}19. Bryer ${encodedHyphen} secondary character; female vampire; leader of Woodland Park group of vampires; partnered with Cleve. Maggie ${encodedHyphen} primary character; female human; Nurse Practitioner who also works shifts in the ER at Harborview Medical Center in Seattle. James ${encodedHyphen} secondary character; male vampire; member of Robert${encodedApostrophe}s Capitol Hill group of vampires.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 1 Scene 2'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.1.2 ${encodedHyphen} January 21, 2020; POV: Maggie.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://www.travelsafe-abroad.com/cost-of-living/tanzania/'
              aria-label='link to article about Average salary in Tanzania'
              className='link'
            >
              Average salary in Tanzania
            </a>
            {parse(` (2022) $2720/yr. Average price of Seattle Capitol Hill neighborhood `)}
            <a
              href='https://www.apartmentlist.com/renter-life/average-rent-in-seattle/'
              aria-label='link to article about Average price of apartments in Capitol Hill neighborhood of Seattle'
              className='link'
            >
              one-bedroom apartment
            </a>
            {parse(`: $2400/mo.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: Rama ${encodedHyphen} secondary character; male human; ER Nurse who works in the ER at Harborview Medical Center in Seattle; works for Althea. Althea ${encodedHyphen} tertiary character; female human; ER Head Nurse who works in the ER at Harborview Medical Center in Seattle; manages Rama and Maggie.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 1 Scene 3'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.1.3 ${encodedHyphen} January 22, 2020; POV: Rix.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 1 Scene 4'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.1.4 ${encodedHyphen} January 23 to 24, 2020; POV: Rix.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 1 Scene 5'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.1.5 ${encodedHyphen} January 25, 2020; POV: Rix.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 1 Scene 6'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.1.6 ${encodedHyphen} January 26 to 27, 2020; POV: Rix.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Character introductions: Nalini ${encodedHyphen} tertiary character; female human; Rix${encodedApostrophe}s manager at an Indian tech company for which he contracts. Cleve ${encodedHyphen} secondary character; male vampire; second in command of Woodland Park group of vampires; partnered with Bryer.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 1 Scene 7'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.1.7 ${encodedHyphen} January 27, 2020; POV: Rix.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 1 Scene 8'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.1.8 ${encodedHyphen} January 29, 2020; POV: Rix.`)}
          </div>
        </div>
      </div>
    </div>
  const v2C2Element: ReactElement =
    <div className='container'>
      <div aria-label='Volume 2 Chapter 2' className='section justify-start'>
        <div aria-label='Volume 2 Chapter 2 Scene 1'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.2.1 ${encodedHyphen} January 31 to February 7, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://www.cnbc.com/2020/09/28/a-timeline-of-the-insidious-path-the-coronavirus-took-around-the-world-to-kill-more-than-1-million.html/'
              aria-label='link to CNBC article on China surpassed 200 COVID-19 deaths'
              className='link'
            >
              China surpassed 200 COVID-19 deaths
            </a>
            {parse(`.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 2 Scene 2'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.2.2 ${encodedHyphen} February 8, 2020; POV: Rix.`)}
          </div>
          <div className='content-page-content-no-spread'>
            Lighthouse Roasters (see 2.2.1).
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 2 Scene 3'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.2.3 ${encodedHyphen} February 8, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19, vampire violence, potential non-consensual sex, sexual abuse, rape.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 2 Scene 4'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.2.4 ${encodedHyphen} February 17, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Lighthouse Roasters (see 2.2.1). `)}
            <a
              href='https://www.cnbc.com/2020/09/28/a-timeline-of-the-insidious-path-the-coronavirus-took-around-the-world-to-kill-more-than-1-million.html/'
              aria-label='link to CNBC article on the WHO naming COVID-19'
              className='link'
            >
              {parse(`The WHO named the virus COVID${encodedHyphen}19`)}
            </a>
            {parse(`. `)}
            <a
              href='https://www.cnbc.com/2020/09/28/a-timeline-of-the-insidious-path-the-coronavirus-took-around-the-world-to-kill-more-than-1-million.html/'
              aria-label='link to CNBC article on the WHO naming COVID-19'
              className='link'
            >
              {parse(`Chinese healthworker infections and deaths`)}
            </a>
            {parse(`. `)}
            <a
              href='https://www.cdc.gov/museum/timeline/covid19.html/'
              aria-label='link to CDC article on the first US COVID-19 confirmed case'
              className='link'
            >
              {parse(`First US COVID${encodedHyphen}19 confirmed case`)}
            </a>
            {parse(` in Everett, Washington.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 2 Scene 5'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.2.5 ${encodedHyphen} February 22, 2020; POV: Maggie; CW: references to COVID${encodedHyphen}19, COVID${encodedHyphen}19 Death.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`China reported `)}
            <a
              href='https://www.devex.com/news/covid-19-in-2020-a-timeline-of-the-coronavirus-outbreak-99634/'
              aria-label='link to Devex article on the 2020 COVID-19 timeline'
              className='link'
            >
              {parse(`the deaths of the director of a Wuhan hospital and a respiratory doctor`)}
            </a>
            {parse(`. Chinese `)}
            <a
              href='https://www.businessinsider.com/coronavirus-infects-healthcare-workers-china-deaths-2020-2/'
              aria-label='link to CNBC article on the WHO naming COVID-19'
              className='link'
            >
              {parse(`ICU nurses in diapers`)}
            </a>
            {parse(`.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 2 Scene 6'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.2.6 ${encodedHyphen} February 28, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19, COVID${encodedHyphen}19 Death.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://www.cdc.gov/media/releases/2020/s0229-COVID-19-first-death.html/'
              aria-label='link to CDC article on the first US COVID-19 death'
              className='link'
            >
              {parse(`First US COVID${encodedHyphen}19 death`)}
            </a>
            {parse(`.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 2 Scene 7'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.2.7 ${encodedHyphen} March 3, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19, empty store shelves, non${encodedHyphen}graphic vampire violence.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://www.seattlemet.com/health-and-wellness/2020/08/seattle-s-coronavirus-timeline-from-toilet-paper-to-mask-laws/'
              aria-label='link to Seattle Times article on early impacts of COVID-19'
              className='link'
            >
              {parse(`Empty store shelves`)}
            </a>
            {parse(`, partial lockdown announcement, etc.`)}
          </div>
        </div>
      </div>
    </div>
  const v2C3Element: ReactElement =
    <div className='container'>
      <div aria-label='Volume 2 Chapter 3' className='section justify-start'>
        <div aria-label='Volume 2 Chapter 3 Scene 1'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.3.1 ${encodedHyphen} March 12, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19, quarantine.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`The Sounders hosted 33,000 fans at match; `)}
            <a
              href='https://www.seattlemet.com/health-and-wellness/2020/08/seattle-s-coronavirus-timeline-from-toilet-paper-to-mask-laws/'
              aria-label='link to Seattle Met article on early impacts of COVID-19'
              className='link'
            >
              {parse(`the WHO declared a pandemic`)}
            </a>
            {parse(`, prompting quarantines and work from home decisions, WA Gov Inslee bans gatherings of greater than 250, Seattle restaurants providing meals for hospital workers.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 3 Scene 2'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.3.2 ${encodedHyphen} March 19, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19, quarantine, homeless encampments.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 3 Scene 3'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.3.3 ${encodedHyphen} March 22 to 23, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19, disaster at NYC ICUs.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`${encodedQuote}`)}
            <a
              href='https://www.youtube.com/watch?v=_fzJGxpcenc/'
              aria-label='link to The Best of Times by Styx'
              className='link'
            >
              The Best of Times
            </a>
            {parse(`${encodedQuote} by Styx. `)}
            <a
              href='https://en.wikipedia.org/wiki/COVID-19_pandemic_in_Maharashtra#March_2020/'
              aria-label='link to Wikipedia article on COVID-19 timeline in Mharashta, India'
              className='link'
            >
              Timeline Maharashtra
            </a>
            {parse(` (Mumbai${encodedApostrophe}s state). Washington State `)}
            <a
              href='https://www.governor.wa.gov/news-media/inslee-announces-stay-home-stay-healthy%C2%A0order/'
              aria-label="link to Washington State Governor's post on stay at home order"
              className='link'
            >
              stay at home mandate
            </a>
            {parse(`. `)}
            <a
              href='https://www.washington.edu/news/2021/03/04/a-year-with-covid-19-a-chronology-of-how-the-uw-adapted-and-responded-to-the-pandemic/'
              aria-label="link to University of Washington chronology of 2020 year"
              className='link'
            >
              Other relevant links
            </a>
            {parse(` during this same time period. `)}
            <a
              href='https://scanpublichealth.org/updates/2020-04-17/'
              aria-label="link to University of Washington SCAN home testing"
              className='link'
            >
              SCAN Home Testing
            </a>
            {parse(` (we had the first home testing in the nation), launched 3/23/20. Some of the `)}
            <a
              href='https://nymag.com/intelligencer/2021/03/coronavirus-nyc-one-year-anniversary.html/'
              aria-label="link to New York Magazince one year anniversary article"
              className='link'
            >
              chaos in New York City
            </a>
            {parse(`. And `)}
            <a
              href='https://gothamist.com/news/remembering-march-2020-nyc-when-times-came-end/'
              aria-label="link to Gothamist remembering March 2020 article"
              className='link'
            >
              {parse(`When The ${encodedQuote}Before Times${encodedQuote} Came To An End`)}
            </a>
            {parse(`.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 3 Scene 4'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.3.4 ${encodedHyphen} March 26, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`Seattle `)}
            <a
              href='https://artbeat.seattle.gov/2020/03/26/seattle-comes-together-to-celebrate-people-on-the-front-lines-in-makeajoyfulnoise/'
              aria-label='link to City of Seattle Artbeat article on Make a Joyful Noise campaign'
              className='link'
            >
              {parse(`${encodedHashmark}MakeAJoyfulNoise`)}
            </a>
            {parse(` at 8pm.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 3 Scene 5'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.3.5 ${encodedHyphen} April 4, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19; COVID death.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`New York City `)}
            <a
              href='https://www.youtube.com/watch?v=g-4_pSfz-Nc&t=39s/'
              aria-label='link to Inside Edition video of NYC nurses with no PPE'
              className='link'
            >
              {parse(`Mt Sinai Nurses`)}
            </a>
            {parse(` with no PPE, wearing garbage bags. `)}
            <a
              href='https://www.nytimes.com/2020/05/27/opinion/coronavirus-morgue-trucks-nyc.html/'
              aria-label='link to New York Times article on freezer truck morgues'
              className='link'
            >
              {parse(`Freezer truck morgues`)}
            </a>
            {parse(`.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 3 Scene 6'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.3.6 ${encodedHyphen} April 6, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19, quarantine, homelessness.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='http://www.canvassupply.net/'
              aria-label='link to Canvas Supply Company'
              className='link'
            >
              {parse(`Canvas Supply Company`)}
            </a>
            {parse(`. `)}
            <a
              href='https://www.instagram.com/p/B-s2VHFgWVA/'
              aria-label="link to Ramona Ridgewell's Instagram photos of Ballard Ave Murals"
              className='link'
            >
              {parse(`Ballard Ave Murals (1)`)}
            </a>
            {parse(`; `)}
            <a
              href='https://www.instagram.com/p/B-s12meANag/'
              aria-label="link to Ramona Ridgewell's Instagram photos of Ballard Ave Murals"
              className='link'
            >
              {parse(`Ballard Ave Murals (2)`)}
            </a>
            {parse(`; `)}
            <a
              href='https://www.instagram.com/p/B-s1TheA8zX/'
              aria-label="link to Ramona Ridgewell's Instagram photos of Ballard Ave Murals"
              className='link'
            >
              {parse(`Ballard Ave Murals (3)`)}
            </a>
            {parse(`, taken by the author. Lighthouse Roasters (see 2.2.1).`)}
          </div>
        </div>
      </div>
    </div>
  const v2C4Element: ReactElement =
    <div className='container'>
      <div aria-label='Volume 2 Chapter 4' className='section justify-start'>
        <div aria-label='Volume 2 Chapter 4 Scene 1'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.4.1 ${encodedHyphen} April 7, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`New York suffered its `)}
            <a
              href='https://whatthefuckjusthappenedtoday.com/2020/04/07/day-1174/'
              aria-label='link to WTFJHT chronical of April 7, 2020'
              className='link'
            >
              {parse(`highest single${encodedHyphen}day death toll`)}
            </a>
            {parse(`. ${encodedQuote}`)}
            <a
              href='https://www.nytimes.com/2020/05/27/opinion/coronavirus-morgue-trucks-nyc.html/'
              aria-label='link to New York Times article on freezer truck morgues'
              className='link'
            >
              {parse(`Piece of My Heart`)}
            </a>
            {parse(`${encodedQuote} and ${encodedQuote}I${encodedApostrophe}d Rather Go Blind${encodedQuote} by Etta James. Harborview Medical Center (see 1.2.5) ER nurses began wearing masks throughout their shift; a local company spent time developing and 3D printing face masks; my source is a Harborview ER Nurse that I know.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 4 Scene 2'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.4.2 ${encodedHyphen} April 8 to 9, 2020; POV: Rix; CW: references to COVID${encodedHyphen}19.`)}
          </div>
          <div className='content-page-content-no-spread'>
            <a
              href='https://en.wikipedia.org/wiki/Gas_Works_Park/'
              aria-label='link to Wikipedia article on Gas Works Park'
              className='link'
            >
              {parse(`Gas Works Park`)}
            </a>
            {parse(`.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 4 Scene 3'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.4.3 ${encodedHyphen} April 11, 2020; POV: Rix; CW: homelessness, threatened violence against children, PTSD, references to COVID${encodedHyphen}19.`)}
          </div>
          <div className='content-page-content-no-spread'>
            {parse(`The `)}
            <a
              href='https://www.kuow.org/stories/i-was-baptized-here-i-thought-i-d-have-my-memorial-there-university-district-bids-adieu-to-historic-church/'
              aria-label='link to KUOW article about University Temple United Methodist Church'
              className='link'
            >
              {parse(`University Temple United Methodist Church`)}
            </a>
            {parse(`; 4326 University Way NE, Seattle, WA 98105; demolished in June of 2021.`)}
            <a
              href='https://en.wikipedia.org/wiki/Blue_Moon_Tavern/'
              aria-label='link to Wikipedia article on the Blue Moon Tavern'
              className='link'
            >
              {parse(`Blue Moon Tavern`)}
            </a>
            {parse(`, 712 NE 45th St, Seattle, WA 98105.`)}
            <a
              href='https://www.wallyhood.org/2021/05/last-call-for-floating-bridge-brewing/#gsc.tab=0/'
              aria-label='link to Wallyhood article on the Floating Bridge Brewing'
              className='link'
            >
              {parse(`Floating Bridge Brewing`)}
            </a>
            {parse(`; 722 NE 45th St, Seattle, WA 98105, a casualty of the pandemic in May 2021, now home to Ladd & Lass Brewing.`)}
            <a
              href='https://www.ddir.com/'
              aria-label="link to Dick's Drive-In"
              className='link'
            >
              {parse(`Dick${encodedApostrophe}s Drive${encodedHyphen}In`)}
            </a>
            {parse(`; 111 NE 45th St, Seattle, WA 98105${encodedMDash}since 1954, original of a chain dishing out burgers, fries ${encodedAmpersand} hand${encodedHyphen}dipped shakes (open late).`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 4 Scene 4'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.4.4 ${encodedHyphen} April 16, 2020; POV: Rix; CW: vampire violence.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 4 Scene 5'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.4.5 ${encodedHyphen} April 18, 2020; POV: Rix.`)}
            <div className='content-page-content-no-spread'>
            </div>
            <a
              href='https://www.space.com/lyrid-meteor-shower-2020-amateur-photos.htm/'
              aria-label='link to Space article about Lyrid Meteor Shower'
              className='link'
            >
              {parse(`Lyrid Meteor Shower`)}
            </a>
            {parse(`.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 4 Scene 6'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.4.6 ${encodedHyphen} April 23, 2020; POV: Rix; CW: vampire violence, memories of prison camp, PTSD.`)}
          </div>
        </div>
        <div aria-label='Volume 2 Chapter 4 Scene 7'
          className='section footnote-section'
        >
          <div className='content-page-content-no-spread'>
            {parse(`2.4.7 ${encodedHyphen} May 1, 2020; POV: Rix; CW: loss of housing.`)}
          </div>
        </div>
      </div>
    </div>

  const bookFootnotes: BookFootnotesProps = {
    BookTitle: 'Being a Vampire',
    V1Title: 'Volume One: Vampire Existence',
    V1C1Title: 'Safe Place',
    V1C2Title: 'Intentions',
    V1C3Title: 'Promising',
    V1C4Title: 'Trust',
    V2Title: 'Volume Two: Vampire Heart',
    V2C1Title: 'Friends',
    V2C2Title: 'Death',
    V2C3Title: 'Hungry',
    V2C4Title: 'Feeling Safe',
    BookRoute: 'svt-b1-being-a-vampire',
    Vol1Ch1: v1C1Element,
    Vol1Ch2: v1C2Element,
    Vol1Ch3: v1C3Element,
    Vol1Ch4: v1C4Element,
    Vol2Ch1: v2C1Element,
    Vol2Ch2: v2C2Element,
    Vol2Ch3: v2C3Element,
    Vol2Ch4: v2C4Element,
  }
  
  return (
    <BookFootnotes {...bookFootnotes} />
	)
}
export default FootnotesBeingAVampireRoute